import { defineComponent as n, openBlock as o, createBlock as c, unref as l, mergeProps as r, withCtx as p, createElementVNode as h } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconThumbsUpOutlined",
  __name: "IconThumbsUpOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (u, e) => (o(), c(l(m), r(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        h("path", {
          "fill-rule": "evenodd",
          d: "M19.73 11.934a2 2 0 0 0 .533-.36 1.924 1.924 0 0 0 0-2.814c-.41-.384-.977-.593-1.638-.593H12.54l.476-2.383a3.046 3.046 0 0 0-1.624-3.323 1.21 1.21 0 0 0-1.648.594l-3.172 7.191a5 5 0 0 0-.165.42H4.375a1.25 1.25 0 0 0-1.25 1.25v6a1.25 1.25 0 0 0 1.25 1.25h2.5l.08-.004a2.24 2.24 0 0 0 1.42.505h7.75c.66 0 1.229-.21 1.638-.594a1.92 1.92 0 0 0 .464-2.146c.706-.343 1.124-1.013 1.13-1.754a1.9 1.9 0 0 0-.25-.968 1.924 1.924 0 0 0 .623-2.271M6.139 17.667a2 2 0 0 1-.014-.25v-5.052l.004-.199H4.625v5.5h1.514m11.577-2.186c-.091.086-.268.185-.591.185h-1.5a.75.75 0 1 0 0 1.5h.5c.34 0 .522.103.612.188a.424.424 0 0 1 0 .625c-.09.085-.273.188-.612.188h-7.75a.75.75 0 0 1-.75-.75v-5.052a3.75 3.75 0 0 1 .319-1.514l3.037-6.884a1.55 1.55 0 0 1 .565 1.522L10.89 8.77a.75.75 0 0 0 .735.898h7c.34 0 .521.102.612.187a.424.424 0 0 1 0 .625c-.09.085-.273.188-.612.188h-2.5a.75.75 0 0 0 0 1.5h1.5c.34 0 .521.102.612.187a.424.424 0 0 1 0 .625c-.09.085-.273.188-.612.188l-.45-.001h-1.05a.75.75 0 0 0 0 1.5h1.006c.336.002.51.104.596.185a.42.42 0 0 1 .13.309.45.45 0 0 1-.142.321",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
